import { Config } from "../../Config";
import { ILaya } from "../../ILaya";
export class Browser {
    static __init__() {
        var _a;
        let Laya = window.Laya || ILaya.Laya;
        if (Browser._window)
            return Browser._window;
        let win = Browser._window = window;
        let doc = Browser._document = win.document;
        let u = Browser.userAgent = win.navigator.userAgent;
        let maxTouchPoints = win.navigator.maxTouchPoints || 0;
        let platform = win.navigator.platform;
        let miniGame;
        if (!!window.conch) {
            miniGame = ["nativeMiniGame", "MiniAdapter", "native"];
        }
        if (!!window.conch) {
            Config.fixedFrames = false;
        }
        if ("my" in Browser.window) {
            if (u.indexOf('TB/') > -1 || u.indexOf('Taobao/') > -1 || u.indexOf('TM/') > -1) {
                miniGame = ["tbMiniGame", "TBMiniAdapter", "my"];
            }
            else if (u.indexOf('AlipayMiniGame') > -1) {
                miniGame = ["aliPayMiniGame", "ALIMiniAdapter", "my"];
            }
        }
        if (((u.indexOf('OPPO') == -1 && u.indexOf("MiniGame") > -1) || u.indexOf('runtime') != -1 || (u.indexOf('miniprogram') != -1 && window.isWXMiMi)) && "wx" in Browser.window) {
            if ("tt" in Browser.window) {
                miniGame = ["ttMiniGame", "TTMiniAdapter", "tt"];
            }
            else if ("bl" in Browser.window) {
                miniGame = ["biliMiniGame", "BLMiniAdapter", null];
            }
            else if ("qq" in Browser.window) {
                miniGame = ["qqMiniGame", "QQMiniAdapter", null];
            }
            else {
                miniGame = ["wxMiniGame", "MiniAdpter", "wx"];
            }
        }
        if ("hbs" in Browser.window) {
            miniGame = ["hwMiniGame", "HWMiniAdapter", null];
        }
        if (u.indexOf("SwanGame") > -1) {
            miniGame = ["bdMiniGame", "BMiniAdapter", null];
        }
        if (u.indexOf('QuickGame') > -1) {
            miniGame = ["miMiniGame", "KGMiniAdapter", "qg"];
        }
        if (u.indexOf('OPPO') > -1 && u.indexOf('MiniGame') > -1) {
            miniGame = ["qgMiniGame", "QGMiniAdapter", "qg"];
            Config.fixedFrames = false;
        }
        if (u.indexOf('VVGame') > -1) {
            miniGame = ["vvMiniGame", "VVMiniAdapter", "qg"];
            Config.fixedFrames = false;
        }
        if (miniGame != null) {
            Browser.window[miniGame[0]](Laya, Laya);
            Laya[miniGame[1]].enable();
            if (!Browser.onLayaRuntime) {
                Browser.miniGameContext = Browser.window[miniGame[2]];
            }
        }
        win.trace = console.log;
        win.requestAnimationFrame = win.requestAnimationFrame || win.webkitRequestAnimationFrame || win.mozRequestAnimationFrame || win.oRequestAnimationFrame || win.msRequestAnimationFrame || function (fun) {
            return win.setTimeout(fun, 1000 / 60);
        };
        var bodyStyle = doc.body.style;
        bodyStyle.margin = 0;
        bodyStyle.overflow = 'hidden';
        bodyStyle['-webkit-user-select'] = 'none';
        bodyStyle['-webkit-tap-highlight-color'] = 'rgba(200,200,200,0)';
        var metas = doc.getElementsByTagName('meta');
        let viewportContent = {
            "width": "device-width",
            "initial-scale": "1.0",
            "minimum-scale": "1.0",
            "maximum-scale": "1.0",
            "user-scalable": "no"
        };
        let viewport;
        for (const meta of metas) {
            if (meta.name == "viewport") {
                viewport = meta;
                break;
            }
        }
        if (!viewport) {
            viewport = doc.createElement('meta');
            viewport.name = 'viewport';
            (_a = doc.getElementsByTagName('head')[0]) === null || _a === void 0 ? void 0 : _a.appendChild(viewport);
        }
        else {
            let arr = (viewport.content || "").split(",");
            for (let ele of arr) {
                let arr2 = ele.split("=");
                if (!viewportContent[arr2[0].trim()])
                    viewportContent[arr2[0]] = arr2[1];
            }
        }
        viewport.content = Object.keys(viewportContent).map(k => k + "=" + viewportContent[k]);
        Browser.onMobile = u.indexOf("Mobile") > -1;
        Browser.onIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        Browser.onIPhone = u.indexOf("iPhone") > -1;
        Browser.onMac = u.indexOf("Mac OS X") > -1;
        Browser.onIPad = u.indexOf("iPad") > -1 || (platform === 'MacIntel' && maxTouchPoints > 1);
        Browser.onAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;
        Browser.onOpenHarmonyOS = u.indexOf('OpenHarmony') > -1;
        Browser.onWP = u.indexOf("Windows Phone") > -1;
        Browser.onQQBrowser = u.indexOf("QQBrowser") > -1;
        Browser.onMQQBrowser = u.indexOf("MQQBrowser") > -1 || (u.indexOf("Mobile") > -1 && u.indexOf("QQ") > -1);
        Browser.onIE = !!win.ActiveXObject || "ActiveXObject" in win;
        Browser.onWeiXin = u.indexOf('MicroMessenger') > -1;
        Browser.onSafari = u.indexOf("Safari") > -1 && u.indexOf("Chrome") === -1;
        Browser.onChrome = u.indexOf("Chrome") > -1;
        Browser.onPC = !Browser.onMobile;
        Browser.onFirefox = u.indexOf('Firefox') > -1;
        Browser.onEdge = u.indexOf('Edge') > -1 || u.indexOf('Edg') > -1;
        Browser.onMiniGame = u.indexOf('MiniGame') > -1;
        Browser.onBDMiniGame = u.indexOf('SwanGame') > -1;
        Browser.onLayaRuntime = !!window.conch;
        if (u.indexOf('OPPO') > -1 && u.indexOf('MiniGame') > -1) {
            Browser.onQGMiniGame = true;
            Browser.onMiniGame = false;
        }
        else if ("qq" in Browser.window && u.indexOf('MiniGame') > -1) {
            Browser.onQQMiniGame = true;
            Browser.onMiniGame = false;
        }
        else if ("bl" in Browser.window && u.indexOf('MiniGame') > -1) {
            Browser.onBLMiniGame = true;
            Browser.onMiniGame = false;
        }
        else if ("tt" in Browser.window && u.indexOf('MiniGame') > -1) {
            Browser.onTTMiniGame = true;
            Browser.onMiniGame = false;
        }
        Browser.onHWMiniGame = "hbs" in Browser.window;
        Browser.onVVMiniGame = u.indexOf('VVGame') > -1;
        Browser.onKGMiniGame = u.indexOf('QuickGame') > -1;
        if (u.indexOf('AlipayMiniGame') > -1) {
            Browser.onAlipayMiniGame = true;
            Browser.onMiniGame = false;
        }
        if (u.indexOf('TB/') > -1 || u.indexOf('Taobao/') > -1 || u.indexOf('TM/') > -1) {
            Browser.onTBMiniGame = true;
        }
        if (Browser.onAndroid || Browser.onIOS) {
            if (platform && (platform.indexOf("Win") != -1 || platform.indexOf("Mac") != -1))
                Browser.platform = Browser.PLATFORM_PC;
            else if (Browser.onAndroid)
                Browser.platform = Browser.PLATFORM_ANDROID;
            else
                Browser.platform = Browser.PLATFORM_IOS;
        }
        else
            Browser.platform = Browser.PLATFORM_PC;
        Browser.isTouchDevice = Browser.onMobile || maxTouchPoints > 0 || ('ontouchstart' in window);
        return win;
    }
    static get _isMiniGame() {
        return Browser.onMiniGame || Browser.onBDMiniGame || Browser.onQGMiniGame || Browser.onKGMiniGame || Browser.onVVMiniGame || Browser.onAlipayMiniGame || Browser.onQQMiniGame || Browser.onBLMiniGame || Browser.onTTMiniGame || Browser.onHWMiniGame || Browser.onTBMiniGame || (Browser.window && Browser.window.isWXMiMi);
    }
    static createElement(type) {
        Browser.__init__();
        return Browser._document.createElement(type);
    }
    static getElementById(id) {
        Browser.__init__();
        return Browser._document.getElementById(id);
    }
    static removeElement(ele) {
        if (ele && ele.parentNode)
            ele.parentNode.removeChild(ele);
    }
    static now() {
        return Date.now();
    }
    static get clientWidth() {
        Browser.__init__();
        return Browser._clientWidth || Browser._window.innerWidth || Browser._document.body.clientWidth;
    }
    static set clientWidth(value) {
        Browser._clientWidth = value;
    }
    static get clientHeight() {
        Browser.__init__();
        return Browser._clientHeight || Browser._window.innerHeight || Browser._document.body.clientHeight || Browser._document.documentElement.clientHeight;
    }
    static set clientHeight(value) {
        Browser._clientHeight = value;
    }
    static get width() {
        Browser.__init__();
        return ((ILaya.stage && ILaya.stage.canvasRotation) ? Browser.clientHeight : Browser.clientWidth) * Browser.pixelRatio;
    }
    static get height() {
        Browser.__init__();
        return ((ILaya.stage && ILaya.stage.canvasRotation) ? Browser.clientWidth : Browser.clientHeight) * Browser.pixelRatio;
    }
    static get pixelRatio() {
        if (Browser._pixelRatio < 0) {
            Browser.__init__();
            if (Browser.userAgent.indexOf("Mozilla/6.0(Linux; Android 6.0; HUAWEI NXT-AL10 Build/HUAWEINXT-AL10)") > -1)
                Browser._pixelRatio = 2;
            else {
                Browser._pixelRatio = (Browser._window.devicePixelRatio || 1);
                if (Browser._pixelRatio < 1)
                    Browser._pixelRatio = 1;
            }
        }
        return Browser._pixelRatio;
    }
    static get container() {
        if (!Browser._container) {
            Browser.__init__();
            Browser._container = Browser.createElement("div");
            Browser._container.id = "layaContainer";
            Browser._document.body.appendChild(Browser._container);
        }
        return Browser._container;
    }
    static set container(value) {
        Browser._container = value;
    }
    static get window() {
        return Browser._window || Browser.__init__();
    }
    static get document() {
        Browser.__init__();
        return Browser._document;
    }
    static getQueryString(name) {
        if (Browser.onMiniGame)
            return null;
        if (!window.location || !window.location.search)
            return null;
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        var r = window.location.search.substring(1).match(reg);
        if (r != null)
            return unescape(r[2]);
        return null;
    }
    static getSafariToolbarOffset() {
        return (Browser.window.__innerHeight || Browser.document.body.clientHeight || Browser.document.documentElement.clientHeight) - Browser.window.innerHeight;
    }
    static loadLib(src) {
        return new Promise((resolve, reject) => {
            let script = Browser.document.createElement('script');
            script.onload = function () {
                resolve();
            };
            script.onerror = function () {
                reject(`load ${src} failed`);
            };
            script.src = src;
            Browser.document.body.appendChild(script);
        });
    }
}
Browser.PLATFORM_PC = 0;
Browser.PLATFORM_ANDROID = 1;
Browser.PLATFORM_IOS = 2;
Browser.bundles = new Map();
Browser._pixelRatio = -1;
Browser.mainCanvas = null;
Browser.hanzi = new RegExp("^[\u4E00-\u9FA5]$");
Browser.fontMap = {};
Browser.measureText = function (txt, font) {
    let isChinese = Browser.hanzi.test(txt);
    if (isChinese && Browser.fontMap[font]) {
        return Browser.fontMap[font];
    }
    let ctx = Browser.context;
    ctx.font = font;
    let r = ctx.measureText(txt);
    if (isChinese)
        Browser.fontMap[font] = r;
    return r;
};
let win = window;
win.__getBundle_ = function (bundleId) {
    let bun = Browser.bundles.get(bundleId);
    if (!bun)
        Browser.bundles.set(bundleId, bun = {});
    return bun;
};
win.__setBundle_ = function (bundleId, bun, globalName) {
    let existing = Browser.bundles.get(bundleId);
    if (existing)
        copyProps(existing, bun, "default");
    Browser.bundles.set(bundleId, bun);
    if (globalName)
        win[globalName] = bun;
};
function copyProps(to, from, except) {
    var desc;
    if (from && typeof from === "object" || typeof from === "function") {
        for (let key of Object.getOwnPropertyNames(from))
            if (!to.hasOwnProperty(key) && key !== except)
                Object.defineProperty(to, key, { get: () => from[key], enumerable: !(desc = Object.getOwnPropertyDescriptor(from, key)) || desc.enumerable });
    }
    return to;
}
